import Vue from 'vue';
import campaignService from '../../services/api/Campaigns';
import appConstants from '../../utility/app-constants';
import { CAMPAIGN_LOCALPHONENUMBERS_LOAD_ACTION, CAMPAIGN_TOLLFREEPHONENUMBERS_LOAD_ACTION, CAMPAIGN_DID_GROUP_CHANGED_ACTION, 
         CAMPAIGN_CLEAR_DID_CALCULATION_VALUES_ACTION }  from '../action-types';import { CAMPAIGN_DID_LOAD_MUTATION, CAMPAIGN_ISSINGLE_OR_MULTIPLE_MUTATION, CAMPAIGN_SELECTED_NUMBER_MUTATION, 
    CAMPAIGN_DID_PAGESIZE_MUTATION, CAMPAIGN_DID_LOCAL_SELECTED_MUTATION, CAMPAIGN_UNSELECTED_NUMBER_MUTATION,
    CAMPAIGN_DID_NUMBER_OF_DID_NEEDED_MUTATION, CAMPAIGN_DID_SELECT_ALL_DID_MUTATION, CAMPAIGN_DID_UNSELECT_ALL_DID_MUTATION,
    CAMPAIGN_CLONE_DIDS_MUTATION, CAMPAIGN_PAGE_NUMBER_CHANGED_MUTATION, CAMPAIGN_AVERAGE_TIME_SESSION_TYPE_CHANGED_MUTATION,
    CAMPAIGN_AVERAGE_TIME_SESSION_CHANGED_MUTATION, CAMPAIGN_NUMBER_OF_IMPRESSION_TYPE_CHANGED_MUTATION, CAMPAIGN_NUMBER_OF_IMPRESSION_CHANGED_MUTATION,
    CAMPAIGN_NUMBER_OF_DID_CHANGED_MUTATION, CAMPAIGN_DID_CALCULATION_TYPE_CHANGED_MUTATION, CAMPAIGN_CLEAR_CALCULATION_DIDS_MUTATION, 
    CAMPAIGN_CLEAR_DID_CALCULATION_TYPE_MUTATION,CAMPAIGN_CLEAR_DID_NUMBERS_MUTATION, CAMPAIGN_DID_COUNT_MUTATION } from '../mutation-types';

export const namespaced = true;

// initial state
export const state = {
  namespaced: true,
  state: {
        didUI: {
            campaignId: 0,
            pageSize: 10,
            currentPageNumber:  1,
            isLocal:true,
            didType: appConstants.DID_TYPE_SINGLE,
            dids: [],
            didLoading: false,
            numberOfDidNeeded :1,
            selectTopRadioValue: '',
            didcalculationType: appConstants.IKNOWMYDID,
            numberOfDid: '',
            numberOfImpression: '',
            numberOfImpressionType: '3600',
            averageTimeSession: '',
            averageTimeSessionType: '60',
        },
    }
};

// actions
export const actions = {
    async [CAMPAIGN_LOCALPHONENUMBERS_LOAD_ACTION]({ commit, state }, searchString) {
        let response=[];
        if((state.state.didUI.isLocal && state.state.didUI.campaignId) || searchString){
            let noOfDid = ''
            if(state.state.didUI.numberOfDid)
                noOfDid = state.state.didUI.numberOfDid;
            else if(state.state.didUI.numberOfDidNeeded)
                noOfDid = state.state.didUI.numberOfDidNeeded;
            else
                noOfDid = ''    

            response = await campaignService.getLocalPhoneNumbers(searchString.areaCode,searchString.region,(noOfDid ? noOfDid : ''));
        }
        let notUsedPhoneNumber = response.data.filter(r=>r.used == false);
        const selectedDids = state.state.didUI.dids.filter(r => r.campaignsPhoneNumberId > 0);
        let dupesRemoved = notUsedPhoneNumber.filter(data => !selectedDids.some(did => did.campaignPhoneNumber == data.phoneNumber));
        const mappedDids = dupesRemoved.map((item) => {
                return {
                    campaignId: state.state.didUI.campaignId,
                    campaignsPhoneNumberId: 0,
                    friendlyName: item.friendlyName,
                    location: item.location,
                    campaignPhoneNumber: item.phoneNumber,
                    areaCode:(item.areaCode) ? item.areaCode : 0,
                    checked: false,
                    pageNumber: 0,
                    index: 0,
                    region:item.region
                };
            });

        const mergedDids = selectedDids.concat(mappedDids);
        commit(CAMPAIGN_DID_LOAD_MUTATION, {
            campaignId: state.state.didUI.campaignId,
            campaignsPhoneNumber: mergedDids,
            checked: false,
            reset: false,
            didType: state.state.didUI.didType ? state.state.didUI.didType : appConstants.DID_TYPE_SINGLE,
            campaignCalculation: state.state.didUI,
        });
    },
    async [CAMPAIGN_TOLLFREEPHONENUMBERS_LOAD_ACTION]({ commit }) {
        let noOfDid = ''
        if(state.state.didUI.numberOfDid)
            noOfDid = state.state.didUI.numberOfDid;
        else if(state.state.didUI.numberOfDidNeeded)
            noOfDid = state.state.didUI.numberOfDidNeeded;
        else
            noOfDid = '' 
        const response = await campaignService.getTollFreePhoneNumbers(noOfDid ? noOfDid : '');
        const selectedDids = state.state.didUI.dids.filter(r => r.campaignsPhoneNumberId > 0 && r.checked);
        const dupesRemoved = response.data.filter(data => !selectedDids.some(did => did.campaignPhoneNumber === data.phoneNumber));

        const mappedDids = dupesRemoved.map((item) => {
        return {
            campaignId: state.state.didUI.campaignId,
            campaignsPhoneNumberId: 0,
            friendlyName: item.friendlyName,
            location: item.location,
            campaignPhoneNumber: item.phoneNumber,
            areaCode:(item.areaCode) ? item.areaCode : 0,
            checked: false,
            pageNumber: 0,
            index: 0,
            region:item.region
        };
        });
        const mergedDids = selectedDids.concat(mappedDids);
        commit(CAMPAIGN_DID_LOAD_MUTATION, {
            campaignId: state.state.didUI.campaignId,
            campaignsPhoneNumber: mergedDids,
            checked: false,
            reset: false,
            didType: state.state.didUI.didType ? state.state.didUI.didType : appConstants.DID_TYPE_SINGLE,
            campaignCalculation: state.state.didUI,
        });      
  },
  [CAMPAIGN_DID_GROUP_CHANGED_ACTION]({commit}, pageSize){
    commit(CAMPAIGN_DID_PAGESIZE_MUTATION, pageSize);
    commit(CAMPAIGN_PAGE_NUMBER_CHANGED_MUTATION, 1);
  },
  [CAMPAIGN_CLEAR_DID_CALCULATION_VALUES_ACTION]({commit}){
    commit(CAMPAIGN_CLEAR_CALCULATION_DIDS_MUTATION);
    commit(CAMPAIGN_CLEAR_DID_CALCULATION_TYPE_MUTATION);
  },
}

// mutations
export const mutations = {
    [CAMPAIGN_DID_LOAD_MUTATION](state, didGridData) {
        let paginatedDids = assignCampaignPhoneNumber(didGridData);
        resetDIDValues(state, didGridData, paginatedDids);
        Vue.set(state.state.didUI, 'dids', [...paginatedDids]);
    },

    [CAMPAIGN_ISSINGLE_OR_MULTIPLE_MUTATION](state, didType) {
        state.state.didUI.didType = didType;
        if(didType == appConstants.DID_TYPE_SINGLE){
            state.state.didUI.numberOfDidNeeded = state.state.didUI.numberOfDid = 1;
            state.state.didUI.selectTopRadioValue = '';
            let isDIDSelected = false;
            state.state.didUI.dids.map((did) => { 
                if(did.checked && did.campaignsPhoneNumberId > 0 && isDIDSelected == false) {
                    did.checked = true; isDIDSelected = true;
                }
                else
                { 
                    did.checked = false; 
                }
            });
            state.state.didUI.dids = state.state.didUI.dids.sort((a,b)=> b.checked-a.checked);
        }else {
            state.state.didUI.dids.map((did) => { if(did.campaignsPhoneNumberId > 0) did.checked = true; else did.checked = false });
            if(state.state.didUI.campaignId > 0) {
                state.state.didUI.numberOfDidNeeded = state.state.didUI.numberOfDid = state.state.didUI.dids ? state.state.didUI.dids.filter(row=> row.campaignsPhoneNumberId > 0).length : 1;
                if(state.state.didUI.numberOfDidNeeded == 0 &&state.state.didUI.numberOfDid == 0) {
                   state.state.didUI.numberOfDidNeeded = state.state.didUI.numberOfDid = 1;
                }
            }
        }
    },

    [CAMPAIGN_SELECTED_NUMBER_MUTATION](state, phoneNumber) {
        state.state.didUI.dids.map(did => {
            if(did.campaignPhoneNumber === phoneNumber.campaignPhoneNumber){
                did.checked = true;
            }
            else if(state.state.didUI.didType == appConstants.DID_TYPE_SINGLE) 
                did.checked = false;
            return did;
        });
    },
    [CAMPAIGN_UNSELECTED_NUMBER_MUTATION](state, phoneNumber) {
        state.state.didUI.dids.map(did => {
            if(did.campaignPhoneNumber === phoneNumber.campaignPhoneNumber)
                did.checked = false;
            return did;
        });
    },
    [CAMPAIGN_DID_PAGESIZE_MUTATION](state, pageSize) {
        state.state.didUI.pageSize = pageSize;
        state.state.didUI.dids.map((did,index) => did.pageNumber = parseInt(index / state.state.didUI.pageSize) + 1);
    },
    [CAMPAIGN_DID_LOCAL_SELECTED_MUTATION](state,isLocal){
        state.state.didUI.isLocal = isLocal;
    },
    [CAMPAIGN_CLONE_DIDS_MUTATION](state) {
        state.state.didUI.dids = [];
    },
    [CAMPAIGN_DID_NUMBER_OF_DID_NEEDED_MUTATION](state,numberofDIDNeeded){
        if(numberofDIDNeeded==0){
            numberofDIDNeeded = state.state.didUI.numberOfDidNeeded = 1 ;
        }
        else{
        state.state.didUI.numberOfDidNeeded = numberofDIDNeeded;        
        }
        state.state.didUI.selectTopRadioValue = '';
    },
    [CAMPAIGN_DID_SELECT_ALL_DID_MUTATION]({state}, numberOfDidToBeSelected){
        state.didUI.selectTopRadioValue = 'selectTop';
        state.didUI.dids.map((did) => { did.checked = false; });
        let selectedCount = 0;

        state.didUI.dids.map((did) => {
            if(!did.checked && selectedCount < numberOfDidToBeSelected){
                did.checked = true;
                selectedCount++;
            }
        });
    },
    [CAMPAIGN_DID_UNSELECT_ALL_DID_MUTATION]({state}){
        state.didUI.selectTopRadioValue = 'unSelectAll';
        state.didUI.dids.map((did) => { if(did.checked) did.checked = false; });
    },
    [CAMPAIGN_PAGE_NUMBER_CHANGED_MUTATION](state, currentPageNumber) {
        state.state.didUI.currentPageNumber = currentPageNumber;
    },
    [CAMPAIGN_DID_CALCULATION_TYPE_CHANGED_MUTATION](state, didcalculationType) {
        state.state.didUI.didcalculationType = didcalculationType;
    },
    [CAMPAIGN_NUMBER_OF_DID_CHANGED_MUTATION](state, numberOfDid) {
        state.state.didUI.numberOfDid = numberOfDid;
    },
    [CAMPAIGN_NUMBER_OF_IMPRESSION_CHANGED_MUTATION](state, numberOfImpression) {
        state.state.didUI.numberOfImpression = numberOfImpression;
    },
    [CAMPAIGN_NUMBER_OF_IMPRESSION_TYPE_CHANGED_MUTATION](state, numberOfImpressionType) {
        state.state.didUI.numberOfImpressionType = numberOfImpressionType;
    },
    [CAMPAIGN_AVERAGE_TIME_SESSION_CHANGED_MUTATION](state, averageTimeSession) {
        state.state.didUI.averageTimeSession = averageTimeSession;
    },
    [CAMPAIGN_AVERAGE_TIME_SESSION_TYPE_CHANGED_MUTATION](state, averageTimeSessionType) {
        state.state.didUI.averageTimeSessionType = averageTimeSessionType;
    },
    [CAMPAIGN_CLEAR_CALCULATION_DIDS_MUTATION](state) {
        state.state.didUI.numberOfDid = state.state.didUI.numberOfImpression = state.state.didUI.averageTimeSession = '';
        state.state.didUI.numberOfImpressionType = '3600'
        state.state.didUI.averageTimeSessionType = '60';
    },
    [CAMPAIGN_CLEAR_DID_CALCULATION_TYPE_MUTATION](state) {
        state.state.didUI.didcalculationType = '';
    },
    [CAMPAIGN_CLEAR_DID_NUMBERS_MUTATION](state) {     
        state.state.didUI.dids = state.state.didUI.dids.filter(r => r.campaignsPhoneNumberId > 0);
    },
    [CAMPAIGN_DID_COUNT_MUTATION](state, numberOfDid){
        state.state.didUI.numberOfDid  = numberOfDid;
    }
}

export const getters = {
    selectedDids(){
        return state.state.didUI.dids.filter(did => did.checked);
    }
};

function assignCampaignPhoneNumber(didGridData) {
    let paginatedDids = [];
    if(didGridData && didGridData.campaignsPhoneNumber)
    {
        state.state.didUI.campaignId = didGridData.campaignId;
        paginatedDids = didGridData.campaignsPhoneNumber.map((item,index) => {
            const pageNumber = parseInt(index / state.state.didUI.pageSize) + 1;
            return {
                index: index,
                campaignId: item.campaignId,
                campaignsPhoneNumberId: item.campaignsPhoneNumberId,
                friendlyName: item.friendlyName,
                location: item.location,
                campaignPhoneNumber: item.campaignPhoneNumber,
                areaCode:item.areaCode,
                checked: (didGridData.checked)?true : item.checked,
                pageNumber: pageNumber,
                region:item.region

            };
        });
    }
    return paginatedDids;
}

function resetDIDValues(state, didGridData) {    
    let campaignCalculation = didGridData.campaignCalculation;
    if(didGridData.reset){
        state.state.didUI.pageSize = 10;
        state.state.didUI.currentPageNumber = 1;
        state.state.didUI.didType = didGridData.didType;
        state.state.didUI.selectTopRadioValue = '';
        state.state.didUI.didcalculationType = campaignCalculation.didcalculationType ? campaignCalculation.didcalculationType : appConstants.IKNOWMYDID;
        state.state.didUI.numberOfDid = campaignCalculation.didcalculationType == "calculatedid"? '' : campaignCalculation.numberOfDid == '' ? 1 : campaignCalculation.numberOfDid;
        state.state.didUI.numberOfImpression = campaignCalculation.numberOfImpression;
        state.state.didUI.numberOfImpressionType = campaignCalculation.numberOfImpressionType ? campaignCalculation.numberOfImpressionType : '3600';
        state.state.didUI.averageTimeSession = campaignCalculation.averageTimeSession;
        state.state.didUI.averageTimeSessionType = campaignCalculation.averageTimeSessionType ? campaignCalculation.averageTimeSessionType : '60';
    }
}